import { MessageParams, Message } from './message';
import { fetchSocialProofMessage } from '../api-clients';
import { console } from '../utility/console';
import { TriggeredEventPropertyKey, TriggeredEvent } from '../triggered-event.types';
import { CustomEventName } from '../ungrouped-tracking-rule.types';

interface SocialProofConfig {
  event_name: CustomEventName;
  event_property_key: TriggeredEventPropertyKey;
}

export class SocialProofMessage extends Message {
  private socialProofConfig: SocialProofConfig;

  public constructor({
    message,
    manager,
    eventChunkUploader,
    eventLog,
    token,
    idfv,
    isControlGroup,
    silverEggSetting,
    onActionButtonClick,
    onMessageShow,
    onMessageClose,
  }: MessageParams) {
    super({
      message,
      manager,
      eventChunkUploader,
      eventLog,
      token,
      idfv,
      isControlGroup,
      silverEggSetting,
      onActionButtonClick,
      onMessageShow,
      onMessageClose,
    });

    if (!message.panels?.[0]) throw new Error('message has no panel data');
    if (!message.panels[0].social_proof_event) throw new Error('social proof config is missing');
    this.socialProofConfig = message.panels[0].social_proof_event;
  }

  public async prepareShowProcess({ event }: { event: TriggeredEvent }): Promise<boolean> {
    const eventPropertyValue = event.properties[this.socialProofConfig.event_property_key];
    if (!eventPropertyValue) {
      console.error(
        `Event must include the property value of ${this.socialProofConfig.event_property_key} to show social proof message.`
      );
      return false;
    }

    // 現時点では Message API へリクエストを叩くのは SilverEgg など外部サービスを利用する場合に限られている(ref. repro.rails#11260)
    // TODO: 将来すべての Web メッセージが Message API へのリクエストを経由して表示することになった折には
    // shouldCallMessageApi による判定を消して MessageManager から MessageAPI を叩くよう処理を寄せる
    const response = await fetchSocialProofMessage({
      messageId: this.messageId,
      token: this.token,
      eventPropertyValue,
    }).catch((error) => {
      this.resetMessageVisibilityConditions();
      throw error;
    });

    if (!response.thresholdExceeded) {
      this.resetMessageVisibilityConditions();
      console.info('Aggregated event property value is below threshold.');
      return false;
    }

    this.dom = this.buildDom({
      rawHtml: response.rawHtml,
      rawCss: response.rawCss,
      scopedCssId: this.variantGroupId,
      scopedCss: this.scopedCss,
      position: this.position,
      shouldSanitizeHTML: !this.shouldExecuteScript,
      shouldRespectTargetInHTML: this.isV2Template,
      elementShouldBeEmptyAndInvisible: this.isControlGroup,
    });
    this.script = response.rawJavaScript;
    this.closeButtonClickTrigger = response.closeButtonClickTrigger;
    this.measurementParams = response.measurements;

    return true;
  }
}
